

<!-- Start of Quick search common component -->
    <app-quick-search 
      [DefaultFilterArray]="DefaultFilterArray"
      [QuickSearchFilterArray]="quickFilterArray"
      (updateDefaultArray)="updateDefaultArray($event)"
      (clearQuickSearch)="clearQuickSearch($event)">
    </app-quick-search>
<!-- End of Quick search common component -->

<!--Filter Code  -->
<div class="col-lg-12 nopadding">
  <app-filter-panel name="DuallyListedStockFilter" id="DuallyListedStockFilter" [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray"
  [isAddFilter]="false"
  (FilterEvent)="FilterApplyFilterEvent($event)">
  </app-filter-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults) {
  <div class="example-loading-shade">
      <mat-spinner></mat-spinner>
  </div>
  }
  <app-grid name="DuallyListedStockGrid" id="DuallyListedStockGrid" [GridColumns]="GridColumns" [Dataset]="dataSet" [TotalRecords]="totalRecords"
      (RestLimitEvent)="GridChangeLimitEvent($event)" (exportData)="exportToCSV($event)">
  </app-grid>
</div>